// extracted by mini-css-extract-plugin
module.exports = {"label":"_2fcec11","checkbox":"_d66453c","disabled":"_ebb2678","labelError":"_bac82e6","checkboxError":"_445419f","root":"_72345dd"};